module.exports = __webpack_public_path__ + "img/maze_square_g.a6b9e955.svg";